export default __webpack_public_path__ + "238d827b04f1bec4ac0f463231fb11a6.png";